import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './infra/store';

import indexRoutes from './routes';
import { Route, BrowserRouter, Routes, useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import HeaderController from './common/components/Header/HeaderController';
import LeftSideBar from './common/components/LeftSideBar';
import InnerBarPersonalDetailsController from './common/components/InnerBarPersonalDetails/InnerbarPersonalDetailsController';
import AuthController from './pages/Auth/AuthController';
import { useAppDispatch, useAppSelector } from './infra/hooks';
import {
  setInnerbarDashboardAccess,
  setIsHeaderSideBarAccess,
} from '././infra/aggregates/userAccessSlice';

import Loader from './common/Lottifiers/Loader/Loader';
import { useTranslate } from './hooks';
import { languages } from './common/helper';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './api/react-query';
import BaseRoute from './routes/BaseRoute';

function AppRouter() {
  const [isSideBarHeader, setIsSideBarHeader] = useState(false);
  const [isPersonalDetailsSidebar, setIsPersonalDetailsSidebar] =
    useState(false);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { language } = useTranslate();

  React.useEffect(() => {
    const body = document.querySelector('body');

    if (!body) return;

    if (language === languages.ar) {
      body.classList.add('ar');
    } else {
      body.classList.remove('ar');
    }
  }, [language]);

  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const isOnlyAttendanceView = useAppSelector(
    (state) => state.isHRViewSlice.isOnlyAttendanceView,
  );
  const isLangLoader = useAppSelector((state) => state.LoaderSlice.LangLoader);

  useEffect(() => {
    if (window.location.pathname == '/login') {
      dispatch(setIsHeaderSideBarAccess(false));
      setIsSideBarHeader(false);
      setIsPersonalDetailsSidebar(false);
    } else if (
      window.location.pathname == '/dashboard' ||
      window.location.pathname == '/employeeannouncement' ||
      window.location.pathname == '/empNotification' ||
      window.location.pathname == '/employeedirectory' ||
      window.location.pathname == '/empLetterGeneration' ||
      window.location.pathname == '/actionRequired' ||
      window.location.pathname == '/perfomance' ||
      window.location.pathname == '/toDoTask' ||
      window.location.pathname == '/suggestion' ||
      window.location.pathname == '/attendanceException' 
    ) {
      setIsPersonalDetailsSidebar(false);
      setIsSideBarHeader(true);
      dispatch(setIsHeaderSideBarAccess(true));
      dispatch(setInnerbarDashboardAccess(true));
    } else {
      setIsPersonalDetailsSidebar(true);
      dispatch(setIsHeaderSideBarAccess(true));
      setIsSideBarHeader(true);
    }
  }, [location]);

  const appIsUnderMaintenance =
    process.env.REACT_APP_UNDER_MAINTENANCE === 'true' ? true : false;

  if (appIsUnderMaintenance && window.location.pathname !== '/500') {
    window.location.href = '/500';
    return null;
  }

  return (
    <>
      <PersistGate loading={null} persistor={persistor}>
        {isLangLoader ? (
          <Loader />
        ) : (
          <div>
            {isSideBarHeader && !isHRView && !appIsUnderMaintenance && (
              <>
                <LeftSideBar />
                <HeaderController />
              </>
            )}
            <div
              style={{
                display: 'flex',
                flexWrap: 'nowrap',
              }}
            >
              {!isOnlyAttendanceView && isPersonalDetailsSidebar && (
                <div
                  style={{
                    minWidth: '15em',
                    marginLeft:
                      language == 'ar'
                        ? ''
                        : language == 'en' && !isHRView
                          ? '7em'
                          : '2em',
                    position: 'fixed',
                    marginRight: isHRView
                      ? language == 'ar'
                        ? '1em'
                        : language == 'ar'
                          ? '7em'
                          : ''
                      : language == 'ar'
                        ? '7em'
                        : '',
                    marginTop: isHRView ? '-1em' : '4em',
                  }}
                >
                  <InnerBarPersonalDetailsController />
                </div>
              )}
              <Routes>
                {indexRoutes.map((prop, key) => {
                  return (
                    <Route
                      path={prop.path}
                      key={key}
                      element={prop.component}
                    />
                  );
                })}
              </Routes>
            </div>
          </div>
        )}
        <Routes>
          <Route path={'/'} key={'login'} element={<BaseRoute />} />
          <Route
            path={'/login'}
            key={'login'}
            element={
              <BaseRoute>
                <AuthController />
              </BaseRoute>
            }
          />
        </Routes>
      </PersistGate>
    </>
  );
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
